// reducers/leaderboardReducer.ts
import { SET_LEADERBOARD } from '../actions';
import Action from '../actions';
import { Leaderboard } from '../type';

const initialState: Leaderboard = {
  entries: {
    alltime: [],
    weekly: [],
    daily: [],
  },
  lastUpdates: 0,
  userRank: 0,
};

const leaderboardReducer = (state = initialState, action: Action): Leaderboard => {
  switch (action.type) {
    case SET_LEADERBOARD:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default leaderboardReducer;
